// NOTE: key 'STATE_LIST' is used by many useSelector hooks throughout the app

import registerStateRedux from 'app/resources/state';
import { useSelector } from 'react-redux';

const key = 'STATE_LIST';

export const stateListRedux = registerStateRedux(key, ['LIST']);

export const useStateList = () => useSelector((state) => state[key]);
